export default "__VITE_ASSET__CU$v9gRl__"